import Vue            from 'vue'
import Vuex           from 'vuex'

import UserState      from './modules/UserState'
import AppState       from './modules/AppState'
import AuthState      from './modules/AuthState'
import SupportState   from './modules/SupportState'
import ChallengeState from './modules/ChallengeState'
import ContentState   from './modules/ContentState'
import MessageState   from './modules/MessageState'
import OrderState     from './modules/OrderState'
import PoliciesState  from './modules/PoliciesState'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    UserState,
    AppState,
    AuthState,
    SupportState,
    ChallengeState,
    ContentState,
    MessageState,
    OrderState,
    PoliciesState,
  }
})
